export const isServerError = (status: number): boolean =>
  status === 500 || status === 502 || status === 503 || status === 504;
export const isClientError = (status: number): boolean => status === 404;
export const isCredentialError = (status: number): boolean => status === 400;
export const hasStatusCode = (error: any): error is { status: number } =>
  error && 'status' in error && typeof error.status === 'number';
